import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { VenueTag } from '../models/VenueTag'
import { VENUE_TAGS_URL } from '../utils/urls'

const fetchVenueTags = (params: TableParams) =>
  SBAPI.FetchPaginated<VenueTag[]>(VENUE_TAGS_URL, params)

const fetchVenueTagById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<VenueTag>(`${VENUE_TAGS_URL}/${id}`, params)

const createVenueTag = (VenueTag: FormData) =>
  SBAPI.Post(VENUE_TAGS_URL, VenueTag)

const updateVenueTag = (VenueTag: FormData) =>
  SBAPI.Post(`${VENUE_TAGS_URL}/${VenueTag.get('id')}`, VenueTag)

const deleteVenueTag = (VenueTag: VenueTag) =>
  SBAPI.Delete(`${VENUE_TAGS_URL}/${VenueTag.id}`)

export {
  createVenueTag,
  deleteVenueTag,
  fetchVenueTagById,
  fetchVenueTags,
  updateVenueTag,
}
